//FilterByType_Crime.tsx ==============================================================
import "../Util/Prototypes";

import * as CrimeSearch from "./CrimeSearch";
import * as Default from "../Default";
import * as Settings_Crime from "./Settings_Crime";
import * as Util from "../Util/Util";

import { Button, Checkbox, FormControl, Icon, IconButton, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, SelectChangeEvent } from "@mui/material";

import React from "react";

export let selectedCrimeTypes: string[];

let ss: Settings_Crime.iSS; //Settings.
let selectAllDisabled: boolean = false;
let clearAllDisabled: boolean = true;
let maxCrimeTypes: number;

//Setters.
export let resetAllCrimeTypes: boolean = false;
export function setResetAllCrimeTypes(resetAll: boolean) {
   resetAllCrimeTypes = resetAll;
}

interface iProps {
}

//Render function.
export function Render(props: iProps) {
   Util.logMsg("Top of FilterByType_Crime.Render");

   //Initialize only one time.
   if (typeof ss === "undefined") {
      ss = Settings_Crime.ss; //Get settings.
      maxCrimeTypes = ss.violentCrimes_names.length + ss.propertyCrimes_names.length + ss.narcoticsCrimes_names.length + ss.otherCrimes_names.length;
      selectedCrimeTypes = []; // ss.violentCrimes_names.concat(ss.propertyCrimes_names).concat(ss.narcoticsCrimes_names).concat(ss.otherCrimes_names);
   }

   //Wire up component for each time render is called, but not on refresh.
   const [initComponent, setState] = React.useState(() => {
   });

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
   }, []);

   //Set render values.
   const styles: Default.iStyles = {
      clearButton: { border: '1px solid silver' },
   };

   const ITEM_HEIGHT = 70;
   const ITEM_PADDING_TOP = 8;

   const MenuProps = {
      PaperProps: {
         style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
         },
      },
      autoFocus: false
   };

   //Crime type filters.
   //const [violentCrimes, set_violentCrimes] = React.useState<string[]>(ss.violentCrimes_names);
   //const [propertyCrimes, set_propertyCrimes] = React.useState<string[]>(ss.propertyCrimes_names);
   //const [narcoticsCrimes, set_narcoticsCrimes] = React.useState<string[]>(ss.narcoticsCrimes_names);
   //const [otherCrimes, set_otherCrimes] = React.useState<string[]>(ss.otherCrimes_names);
   const [violentCrimes, set_violentCrimes] = React.useState<string[]>([]);
   const [propertyCrimes, set_propertyCrimes] = React.useState<string[]>([]);
   const [narcoticsCrimes, set_narcoticsCrimes] = React.useState<string[]>([]);
   const [otherCrimes, set_otherCrimes] = React.useState<string[]>([]);

   //Enable select all and clear buttons.
   function enableSelectAndClear() {
      selectAllDisabled = false;
      clearAllDisabled = false;

      if (selectedCrimeTypes.length === maxCrimeTypes) {
         selectAllDisabled = true;
         clearAllDisabled = false;

      } else if (selectedCrimeTypes.length === 0) {
         selectAllDisabled = false;
         clearAllDisabled = true;
      }
   }

   //Violent crimes.
   const handleChange_violentCrimes = (event: SelectChangeEvent<typeof violentCrimes>) => {
      const { target: { value }, } = event;
      set_violentCrimes(typeof value === 'string' ? value.split(',') : value);
      selectedCrimeTypes = propertyCrimes.concat(narcoticsCrimes).concat(otherCrimes).concat(event.target.value);
      enableSelectAndClear();
   };

   //Property crimes.
   const handleChange_propertyCrimes = (event: SelectChangeEvent<typeof propertyCrimes>) => {
      const { target: { value }, } = event;
      set_propertyCrimes(typeof value === 'string' ? value.split(',') : value);
      selectedCrimeTypes = violentCrimes.concat(narcoticsCrimes).concat(otherCrimes).concat(event.target.value);
      enableSelectAndClear();
   };

   //Narcotics crimes.
   const handleChange_narcoticsCrimes = (event: SelectChangeEvent<typeof narcoticsCrimes>) => {
      const { target: { value }, } = event;
      set_narcoticsCrimes(typeof value === 'string' ? value.split(',') : value);
      selectedCrimeTypes = violentCrimes.concat(propertyCrimes).concat(otherCrimes).concat(event.target.value);
      enableSelectAndClear();
   };

   //Other crimes.
   const handleChange_otherCrimes = (event: SelectChangeEvent<typeof otherCrimes>) => {
      const { target: { value }, } = event;
      set_otherCrimes(typeof value === 'string' ? value.split(',') : value);
      selectedCrimeTypes = violentCrimes.concat(propertyCrimes).concat(narcoticsCrimes).concat(event.target.value);
      enableSelectAndClear();
   };

   //Select all crime types.
   function selectAllCrimeTypes() {
      selectAllDisabled = true;
      clearAllDisabled = false;
      set_violentCrimes(ss.violentCrimes_names);
      set_propertyCrimes(ss.propertyCrimes_names);
      set_narcoticsCrimes(ss.narcoticsCrimes_names);
      set_otherCrimes(ss.otherCrimes_names);
      selectedCrimeTypes = ss.violentCrimes_names.concat(ss.propertyCrimes_names).concat(ss.narcoticsCrimes_names).concat(ss.otherCrimes_names);
   }

   //Clear all crime types.
   function clearAllCrimeTypes() {
      selectAllDisabled = false;
      clearAllDisabled = true;
      set_violentCrimes([]);
      set_propertyCrimes([]);
      set_narcoticsCrimes([]);
      set_otherCrimes([]);
      selectedCrimeTypes = [];

      if (!resetAllCrimeTypes) {
         CrimeSearch.autoSearch();
      }
      resetAllCrimeTypes = false;
   }

   if (resetAllCrimeTypes) {
      clearAllCrimeTypes();
   }

   return (
      <div className="app-flex-column-between">

         <div className="app-flex-row-between">
            <div>Filter by Crime Type</div>

            <div style={{ margin: 9, marginLeft: 23, marginRight: 23 }}>
               <Button variant="outlined" color="info" onClick={selectAllCrimeTypes} disabled={selectAllDisabled} title="Select All Crime Types" aria-label="Select All Crime Types">
                  Select All
               </Button>
            </div>

            <div>
               <IconButton style={styles.clearButton} color="primary" size="small" onClick={clearAllCrimeTypes} disabled={clearAllDisabled} title="Clear Crime Type filters" aria-label="Clear Crime Type Filters">
                  <Icon fontSize="small">clear</Icon>
               </IconButton>
            </div>
         </div>

         <FormControl sx={{ m: 1, width: 300 }}>
            <InputLabel id="violent-crimes-checkbox-label">Violent Crimes</InputLabel>
            <Select
               labelId="violent-crimes-checkbox-label"
               id="violent-crimes-checkbox"
               multiple
               value={violentCrimes}
               onChange={handleChange_violentCrimes}
               input={<OutlinedInput label="Violent Crimes" />}
               renderValue={(selected) => selected.join(", ")}
               MenuProps={MenuProps}
            >
               {ss.violentCrimes_names.map((name) => (
                  <MenuItem key={name} value={name}>
                     <Checkbox checked={violentCrimes.indexOf(name) > -1} />
                     <ListItemText primary={name} />
                  </MenuItem>
               ))}
            </Select>
         </FormControl>

         <FormControl sx={{ m: 1, width: 300 }}>
            <InputLabel id="property-crimes-checkbox-label">Property Crimes</InputLabel>
            <Select
               labelId="property-crimes-checkbox-label"
               id="property-crimes-checkbox"
               multiple
               value={propertyCrimes}
               onChange={handleChange_propertyCrimes}
               input={<OutlinedInput label="Property Crimes" />}
               renderValue={(selected) => selected.join(", ")}
               MenuProps={MenuProps}
            >
               {ss.propertyCrimes_names.map((name) => (
                  <MenuItem key={name} value={name}>
                     <Checkbox checked={propertyCrimes.indexOf(name) > -1} />
                     <ListItemText primary={name} />
                  </MenuItem>
               ))}
            </Select>
         </FormControl>

         <FormControl sx={{ m: 1, width: 300 }}>
            <InputLabel id="narcotics-crimes-checkbox-label">Narcotics</InputLabel>
            <Select
               labelId="narcotics-crimes-checkbox-label"
               id="narcotics-crimes-checkbox"
               multiple
               value={narcoticsCrimes}
               onChange={handleChange_narcoticsCrimes}
               input={<OutlinedInput label="Narcotics" />}
               renderValue={(selected) => selected.join(", ")}
               MenuProps={MenuProps}
            >
               {ss.narcoticsCrimes_names.map((name) => (
                  <MenuItem key={name} value={name}>
                     <Checkbox checked={narcoticsCrimes.indexOf(name) > -1} />
                     <ListItemText primary={name} />
                  </MenuItem>
               ))}
            </Select>
         </FormControl>


         <FormControl sx={{ m: 1, width: 300 }}>
            <InputLabel id="other-crimes-checkbox-label">Other</InputLabel>
            <Select
               labelId="other-crimes-checkbox-label"
               id="other-crimes-checkbox"
               multiple
               value={otherCrimes}
               onChange={handleChange_otherCrimes}
               input={<OutlinedInput label="Other" />}
               renderValue={(selected) => selected.join(", ")}
               MenuProps={MenuProps}
            >
               {ss.otherCrimes_names.map((name) => (
                  <MenuItem key={name} value={name}>
                     <Checkbox checked={otherCrimes.indexOf(name) > -1} />
                     <ListItemText primary={name} />
                  </MenuItem>
               ))}
            </Select>
         </FormControl>

      </div>
   ); //end return.

} //end function.
